import React from 'react';
import { useState } from "react";
import Router from '@/router';
import { Layout } from 'antd';
import Navigation from '@/app/Navigation';
import { useSelector } from 'react-redux';
import { selectAuth } from '@/redux/auth/selectors';
import { UserContext } from '../context/UserContext';
import { CurrencyProvider } from '@/context/CurrencyContext'; //aca la api de las tasas de dolares y euro...
// Asegúrate de que la ruta coincida con donde guardaste el archivo
import '@/style/dark.css';

// 1. Importamos el ConfigProvider
import { ConfigProvider } from '../context/ConfigContext'; 

window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || 
      e.message === 'ResizeObserver loop limit exceeded') {
    const resizeObserverErrDiv = document.getElementById(
      'webpack-dev-server-client-overlay-div'
    );
    const resizeObserverErrShadow = document.getElementById(
      'webpack-dev-server-client-overlay'
    );
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.style.display = 'none';
    }
    if (resizeObserverErrShadow) {
      resizeObserverErrShadow.style.display = 'none';
    }
    e.stopImmediatePropagation();
  }
});

function App() {
  const [language, setLanguage] = useState("es");
  const [company, setCompany] = useState("1");
  const value = { language, setLanguage, company, setCompany };

  const { isLoggedIn } = useSelector(selectAuth);

  // 2. Envolvemos la ruta pública por si alguna vista (como el Login) 
  // llega a necesitar los colores o el logo del ConfigContext
  if (!isLoggedIn) {
    return (
      <ConfigProvider>
        <Router />
      </ConfigProvider>
    );
  } else {
    // 3. Envolvemos la estructura privada de la aplicación
    return (
      <ConfigProvider>
        <UserContext.Provider value={value}>
          <Layout style={{ minHeight: '100vh' }}>
            <Navigation />
            <Layout style={{ minHeight: '100vh' }}>
              <Router isLoggedIn={true} />
            </Layout>
          </Layout>
        </UserContext.Provider>
      </ConfigProvider>
    );
  }
}

export default App;